import { Button, DatePicker, Form, Input, Select } from "antd";

import { ApplicantUserPersonalInformation } from "../../../../generated";
import React, { useState } from "react";
import { FormatDate } from "../../../../constants";
import dayjs from "dayjs";
import { EditProfile } from "./edit-profile";
import {
  APOLLO_DATE_FORMAT,
  DATE_FORMAT,
  GENDERS,
} from "../../../../constants";

const EDIT_TITLE = "View Identity Details";
interface IdentityEditProps {
  personalInformation: ApplicantUserPersonalInformation;
  onCancel: () => void;
  onSave: (applicant: ApplicantUserPersonalInformation) => Promise<void>;
}

export const ApplicantProfileIdentityEdit: React.FC<IdentityEditProps> = ({
  personalInformation,
  onCancel,
  onSave,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm();
  const initialValues = {
    lastName: personalInformation.identityDetails?.lastName,
    restOfName: personalInformation.identityDetails?.restOfName,
    gender: personalInformation.identityDetails?.gender,
    dateOfBirth: personalInformation.identityDetails?.dateOfBirth,
    emailAddress: personalInformation.contactInformation?.emailAddress,
  };

  const IdentityEditForm = (
    <Form
      style={{ width: "50%" }}
      form={form}
      initialValues={initialValues}
      layout="vertical"
      onFinish={async (values) => {
        const identityDetails = {
          lastName: values.lastName,
          restOfName: values.restOfName,
          gender: values.gender,
          dateOfBirth: FormatDate(values.dateOfBirth, APOLLO_DATE_FORMAT),
        };
        const contactInformation = {
          emailAddress: values.emailAddress,
        };
        onSave({
          identityDetails,
          contactInformation,
        });
        setIsSubmitting(true);
      }}
    >
      <Form.Item
        style={{ width: 400 }}
        name={["lastName"]}
        validateTrigger={["onChange", "onBlur"]}
        label="Last Name"
        rules={[
          {
            required: true,
            message: "Please enter Last Name",
          },
        ]}
      >
        <Input placeholder="Last Name" />
      </Form.Item>
      <Form.Item
        style={{ width: 400 }}
        name={["restOfName"]}
        validateTrigger={["onChange", "onBlur"]}
        rules={[
          {
            required: true,
            message: "Please enter Rest of Name",
          },
        ]}
        label="Rest of Name"
      >
        <Input placeholder="Rest of Name" />
      </Form.Item>
      <div style={{ display: "flex", gap: 10 }}>
        <Form.Item
          name={["gender"]}
          rules={[{ required: true, message: "Gender is required" }]}
          label="Gender"
        >
          <Select style={{ width: 100 }} placeholder="Gender">
            {GENDERS.map((item) => {
              return (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          name={["dateOfBirth"]}
          valuePropName="value"
          rules={[{ required: true, message: "Date of Birth is required" }]}
          label="Date of Birth"
          getValueProps={(value) => ({
            value: value ? dayjs(value) : "",
          })}
        >
          <DatePicker
            value={
              personalInformation?.identityDetails?.dateOfBirth
                ? FormatDate(
                    personalInformation?.identityDetails?.dateOfBirth
                  )
                : ""
            }
            format={(value) => value.format(DATE_FORMAT).toUpperCase()}
            />
        </Form.Item>
      </div>
      <Form.Item
        style={{ width: 400 }}
        rules={[
          { required: true, message: "Email is required", type: "email" },
        ]}
        name={["emailAddress"]}
        label="Email"
      >
        <Input placeholder="Email" />
      </Form.Item>
      <div className="flex items-center justify-center gap-4 w-full">
        <Button onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          htmlType="submit"
          style={{ background: "#3F4373", color: "#D9D9D9" }}
          value={"save"}
          loading={isSubmitting}
        >
          Save
        </Button>
      </div>
    </Form>
  );

  return (
    <EditProfile
      title={EDIT_TITLE}
      form={IdentityEditForm}
    />
  );
};
